import { Stack, Text, useTheme } from "@bps/fluent-ui";
import { SoftwarePackageVersion } from "@libs/api/gateways/field/field-ops-gateway.dtos";

interface SoftwarePackageDetailsCardProps {
  softwarePackageVersion?: SoftwarePackageVersion;
}

interface DetailRowProps {
  label: string;
  value?: string;
}

const DetailRow = ({ label, value }: DetailRowProps) => {
  return (
    <Stack horizontal tokens={{ childrenGap: 8 }}>
      <strong>{label}:</strong>
      <span>{value || "--"}</span>
    </Stack>
  );
};

export const SoftwarePackageDetailsCard = ({
  softwarePackageVersion
}: SoftwarePackageDetailsCardProps) => {
  const theme = useTheme();

  return (
    <Stack
      styles={{
        root: {
          border: `1px solid ${theme.palette.neutralLight}`,
          borderRadius: 4,
          padding: theme.spacing.m,
          width: "fit-content",
          maxWidth: "100%"
        }
      }}
      tokens={{ childrenGap: theme.spacing.s1 }}
    >
      <Stack horizontal tokens={{ childrenGap: theme.spacing.l1 }}>
        <Stack grow tokens={{ childrenGap: theme.spacing.s1 }}>
          <Text
            variant="xLarge"
            styles={{ root: { color: theme.palette.themePrimary } }}
          >
            Software Package
          </Text>
          <DetailRow
            label="Name"
            value={softwarePackageVersion?.softwarePackageDisplayName}
          />

          <DetailRow
            label="Code"
            value={softwarePackageVersion?.softwarePackageCode}
          />

          <DetailRow
            label="Description"
            value={softwarePackageVersion?.softwarePackageDescription}
          />

          <DetailRow
            label="Type Code"
            value={softwarePackageVersion?.softwarePackageTypeCode}
          />

          <Text
            variant="xLarge"
            styles={{ root: { color: theme.palette.themePrimary } }}
          >
            Publisher
          </Text>
          <DetailRow
            label="Name"
            value={softwarePackageVersion?.softwarePublisherDisplayName}
          />
          <DetailRow
            label="Code"
            value={softwarePackageVersion?.softwarePublisherCode}
          />

          <DetailRow
            label="Description"
            value={softwarePackageVersion?.softwarePublisherDescription}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
